(function ($) {
  var mainflickityOptions = {
    "imagesLoaded": true,
    "lazyLoad": 1,
    "adaptiveHeight": true,
    "wrapAround": true,
    "pageDots": true
  };
  var navflickityOptions = {
    "asNavFor": ".product-single-slider .carousel-main",
    "cellAlign": 'center',
  	"contain": true,
    "imagesLoaded": true,
    "adaptiveHeight": false,
    "wrapAround": false,
    "prevNextButtons": false,
    "pageDots": false
  };

  $(".product-single-slider .carousel-main").flickity(mainflickityOptions);
  $(".product-single-slider .carousel-nav").flickity(navflickityOptions);

  
})(jq223);